module.exports = __webpack_public_path__ + "media/personal_finance/background-9eeb389c.jpg";